import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import Dashboard from "@/pages/Dashboard";
import ProgramPage from "@/pages/ProgramPage";
import WeekModule from "@/pages/WeekModule";
import CommunityPage from "@/pages/CommunityPage";
import ResourcesPage from "@/pages/ResourcesPage";
import EnrollmentSuccess from "@/pages/EnrollmentSuccess";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children, requireEnrolled = false }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#F7F5F0' }}>
      <p className="text-lg" style={{ fontFamily: 'Cormorant Garamond, serif', color: '#5B665E' }}>Loading...</p>
    </div>
  );
  if (user === false) return <Navigate to="/login" replace />;
  if (requireEnrolled && !user.enrolled) return <Navigate to="/register" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user && user !== false && user.enrolled) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicRoute><LandingPage /></PublicRoute>} />
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/enrollment/success" element={<ProtectedRoute><EnrollmentSuccess /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute requireEnrolled><Dashboard /></ProtectedRoute>} />
          <Route path="/program" element={<ProtectedRoute requireEnrolled><ProgramPage /></ProtectedRoute>} />
          <Route path="/program/:weekNum" element={<ProtectedRoute requireEnrolled><WeekModule /></ProtectedRoute>} />
          <Route path="/community" element={<ProtectedRoute requireEnrolled><CommunityPage /></ProtectedRoute>} />
          <Route path="/resources" element={<ProtectedRoute requireEnrolled><ResourcesPage /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
